import React, { useState } from "react";
import "../asset/css/Register.css";
import { Link } from "react-router-dom";
import { buildApiUrl, fetchJsonWithRetry } from "../config/api";
function Register() {
  const [inputs, setInputs] = useState({});
  const [otpSent, setOtpSent] = useState(false);
  const [showerror, setShowError] = useState(false);
  const [error, setError] = useState("");
  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };
  const doRegister = async (event) => {
    event.preventDefault();
    if (!otpSent) {
      if (inputs.pass !== inputs.cnfpass) {
        setError("Password and confirm password do not match");
        setShowError(true);
        return;
      }

      if (inputs.email !== inputs.cnfemail) {
        setError("Email and confirm email do not match");
        setShowError(true);
        return;
      }

      try {
        const {
          response,
          data,
          error: requestError,
        } = await fetchJsonWithRetry(
          buildApiUrl("auth/register-email"),
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              name: inputs.name,
              email: inputs.email,
              confirmEmail: inputs.cnfemail,
              password: inputs.pass,
              confirmPassword: inputs.cnfpass,
            }),
          },
          { retries: 3, retryDelayMs: 2000 },
        );

        if (response?.ok && data?.success === true) {
          setOtpSent(true);
          setError("OTP sent to your email. Enter it to confirm registration.");
          setShowError(true);
        } else if (response && response.status === 409) {
          setError("User already exists");
          setShowError(true);
        } else if (response && [502, 503, 504].includes(response.status)) {
          setError("Backend is waking up. Please try again in a few seconds.");
          setShowError(true);
        } else if (requestError) {
          setError("Failed to connect with server");
          setShowError(true);
        } else {
          setError(data?.message || "Failed to send OTP");
          setShowError(true);
        }
      } catch (error) {
        console.log("Error ", error);
        setShowError(true);
        setError("Failed to connect with server");
      }
      return;
    }

    try {
      const {
        response,
        data,
        error: requestError,
      } = await fetchJsonWithRetry(
        buildApiUrl("auth/register-verify"),
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: inputs.email,
            otp: inputs.otp,
          }),
        },
        { retries: 3, retryDelayMs: 2000 },
      );

      if (response?.ok && data?.success === true) {
        setError("Account Created Successfully. Please Login");
        setInputs({});
        setOtpSent(false);
        setShowError(true);
      } else if (response?.status === 410) {
        setError(data?.message || "OTP expired. Please request a new one.");
        setShowError(true);
      } else if (response?.status === 403) {
        setError(data?.message || "Invalid OTP");
        setShowError(true);
      } else if (response?.status === 409) {
        setError(data?.message || "User already exists");
        setShowError(true);
      } else if (requestError) {
        setError("Failed to connect with server");
        setShowError(true);
      } else {
        setError(data?.message || "Registration failed");
        setShowError(true);
      }
    } catch (error) {
      console.log("Error ", error);
      setShowError(true);
      setError("Failed to connect with server");
    }
  };
  return (
    <div className="mainContainer">
      <div className="formcard">
        <div>
          <h2 style={{ alignSelf: "center" }}>Register</h2>
        </div>
        <form onSubmit={doRegister}>
          <div>
            <label>Name</label>
            <input
              required
              type="text"
              placeholder="Enter your name"
              value={inputs.name || ""}
              onChange={handleChange}
              name="name"
            />
          </div>
          <div>
            <label>Email</label>
            <input
              required
              type="email"
              placeholder="Enter your email"
              value={inputs.email || ""}
              onChange={handleChange}
              name="email"
            />
          </div>
          <div>
            <label>Confirm Email</label>
            <input
              required
              type="email"
              placeholder="Confirm your email"
              value={inputs.cnfemail || ""}
              onChange={handleChange}
              name="cnfemail"
            />
          </div>
          <div>
            <label>Password</label>
            <input
              required
              type="password"
              placeholder="Enter your password"
              value={inputs.pass || ""}
              onChange={handleChange}
              name="pass"
            />
          </div>
          <div>
            <label>Confirm Password</label>
            <input
              required
              type="password"
              placeholder="Confirm your password"
              value={inputs.cnfpass || ""}
              onChange={handleChange}
              name="cnfpass"
            />
          </div>
          {otpSent ? (
            <div>
              <label>OTP</label>
              <input
                required
                type="text"
                placeholder="Enter OTP sent to your email"
                value={inputs.otp || ""}
                onChange={handleChange}
                name="otp"
              />
            </div>
          ) : null}
          {showerror ? (
            <div>
              <span style={{ color: "red", alignSelf: "center" }}>{error}</span>
            </div>
          ) : null}
          <div>
            <button>
              {otpSent ? "Verify OTP & Create Account" : "Send OTP"}
            </button>
          </div>
          <div>
            <span style={{ alignSelf: "center" }}>
              Already a user ?<Link to="/">Login</Link>{" "}
            </span>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Register;
